exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.introDonate[data-v-0e7ac21b]{display:flex;background:gray;justify-content:space-evenly;padding-top:20px;height:400px;background-image:url(\"/assets/images/Donate-Banner.png\");background-size:cover\n}\n.introDescriptionDonate[data-v-0e7ac21b]{font-size:30px;padding-top:120px\n}\n.introDescriptionDonate p[data-v-0e7ac21b]{font-size:60px;font-weight:900\n}", ""]);

// exports
